import { DefaultCache } from '@app/utils/cache';
import { CacheHandler } from '@app/utils/cache/cache-handler';
import { Observable, pipe, UnaryFunction } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

interface CacheOptions {
  /**
   * If true the cache will be evicted and the value will be loaded again.
   */
  refresh?: boolean;

  /**
   * Time-to-live in ms.
   */
  ttl?: number;
}

// T, O extends ObservableInput<any>>(project: (value: T, index: number) => O, concurrent?: number): OperatorFunction<T, ObservedValueOf<O>>
export function flatMapWithCache<T>(
  project: (value: string, index: number) => Observable<T>
): UnaryFunction<Observable<string>, Observable<T>>;

export function flatMapWithCache<T>(
  project: (value: string, index: number) => Observable<T>,
  options: CacheOptions
): UnaryFunction<Observable<string>, Observable<T>>;

export function flatMapWithCache<T>(
  project: (value: string, index: number) => Observable<T>,
  ttl: number
): UnaryFunction<Observable<string>, Observable<T>>;

export function flatMapWithCache<O>(
  project: (value: string, index: number) => Observable<O>,
  optionsOrTtl?: CacheOptions | number
): UnaryFunction<Observable<string>, Observable<O>> {
  let options: CacheOptions = {
    ttl: 120000,
  };

  if (typeof optionsOrTtl === 'number') {
    options = {
      ...options,
      refresh: false,
      ttl: optionsOrTtl,
    };
  } else {
    options = {
      ...options,
      ...optionsOrTtl,
    };
  }

  return pipe(
    mergeMap((key: string, index: number) => {
      return CacheHandler.get().handle({
        cacheStrategy: DefaultCache(),
        evict: options.refresh,
        ttl: options.ttl,
        key,
        method: () => project(key, index),
      });
    })
  );
}
